import React from 'react';

const Spinner = ({ color }: { color?: string }) => {
    return <div className={`spinner ${color ? 'spinner--' + color : ''}`}></div>;
};

export default Spinner;
